//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
let d=[[[0,"AngleA",1,0],[0,"AngleB",1,0],[0,"MasterOpLabel",1,0],[0,"SensorOpLabel",1,0],[0,"SensorOpName",1,0],[0,"SensorTipDiameter",1,0],[0,"SensorTipLength",1,0],[0,"SensorTipLocation",1,0],[0,"SensorTipSize",1,0],[0,"SensorTipType",1,0],[0,"SensorType",1,0],[0,"TipNumber",1,0],[0,"ToolName",1,0]],[[["count"],"GetSensorTipXyz",{R_:{xyz:""}},0,0],[["xyz"],"SetSensorTipXyz",{},1,0],[["count"],"GetSensorTipIjk",{R_:{ijk:""}},0,0],[["ijk"],"SetSensorTipIjk",{},1,0]],[]];
SPLM.CAM.InspectionSensorBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionSensorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionSensorBuilder.SensorTypes = Object.freeze({
    "Fixed" : "Fixed", "Index" : "Index"});

SPLM.CAM.InspectionSensorBuilder.SensorTipLocationTypes = Object.freeze({
    "Cartesian" : "Cartesian", "Polar" : "Polar", "Vector" : "Vector"});

SPLM.CAM.InspectionSensorBuilder.SensorTipTypes = Object.freeze({
    "Sphere" : "Sphere", "Cylinder" : "Cylinder", "Disk" : "Disk"});

export default SPLM;